import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer';
import { Tooltip } from '@/components/elementary/Tooltip';
import { Done } from '@/components/icons/Done';
import { Info } from '@/components/icons/Info';
import { cn } from '@/lib/styles';
import styles from './FeatureCell.module.css';

// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: No complexity - easy to follow
export function FeatureCell(t0) {
  const $ = _c(16);
  const {
    featureItem,
    yearly,
    defaultChecked
  } = t0;
  if (!featureItem) {
    let t1;
    if ($[0] !== defaultChecked) {
      t1 = defaultChecked ? <Done aria-hidden="true" className="size-5 text-brand-salmon shrink-0" /> : null;
      $[0] = defaultChecked;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const text = yearly ? featureItem.textYearly : featureItem.textMonthly;
  const tooltipLabel = yearly ? featureItem.tooltipLabelYearly : featureItem.tooltipLabelMonthly;
  const tooltipContent = yearly ? featureItem.tooltipContentYearly : featureItem.tooltipContentMonthly;
  if (featureItem.isChecked) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Done aria-hidden="true" className="size-5 text-brand-salmon shrink-0" />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (text || tooltipLabel) {
    let t1;
    if ($[3] !== text) {
      t1 = text ? <CkEditorCSRRenderer htmlContent={text} className={cn(styles["table-cell-content"], "text-balance")} defaultTypography="bodyMedium" /> : null;
      $[3] = text;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[5] !== text || $[6] !== tooltipLabel) {
      t2 = tooltipLabel ? <CkEditorCSRRenderer htmlContent={tooltipLabel} className={cn(styles["table-cell-content"], "text-balance", text ? "lok-text-body-small" : "lok-text-body-medium")} defaultTypography={text ? "bodySmall" : "bodyMedium"} /> : null;
      $[5] = text;
      $[6] = tooltipLabel;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    let t3;
    if ($[8] !== tooltipContent) {
      t3 = tooltipContent ? <Tooltip content={tooltipContent}><span><Info className="text-neutral-light-400 size-4 shrink-0" /></span></Tooltip> : null;
      $[8] = tooltipContent;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== t2 || $[11] !== t3) {
      t4 = <div className="flex items-center gap-2 min-w-0">{t2}{t3}</div>;
      $[10] = t2;
      $[11] = t3;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    let t5;
    if ($[13] !== t1 || $[14] !== t4) {
      t5 = <div className="grid place-items-center text-center">{t1}{t4}</div>;
      $[13] = t1;
      $[14] = t4;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    return t5;
  }
  return null;
}